import type { Faq, Timetable } from '../types/content';

export const timetables: Timetable[] = [
  { name: 'Morning', time: '08:30 – 11:00', note: 'For students who like to start the day with class.' },
  { name: 'Midday', time: '12:00 – 14:30', note: 'For students who want free mornings and evenings.' },
  { name: 'Late afternoon', time: '15:30 – 18:00', note: 'For students who work or study during the day.' },
];

export const sampleStartDates: string[] = ['00 Month 0000', '00 Month 0000', '00 Month 0000', '00 Month 0000'];

export const sharedCourseFaqs: Faq[] = [
  {
    q: 'Do I need to take a level test?',
    a: 'Yes. You take a free online placement test before you arrive. It helps us place you in the right class on your first day.',
  },
  {
    q: 'Can you help me with my visa?',
    a: 'Yes. Our admissions team explains the visa options for your location and helps you prepare your documents after you book.',
  },
  {
    q: 'What happens if I need to change my dates?',
    a: 'Contact our team as early as possible. We will try to move your course to new dates. Our terms explain the rules for each case.',
  },
];
